import { REPEAT_LINKAGE_OPTIONS } from './repeatLinkage'
import { useContext } from 'react'
import { LinkageCreationContext } from '../LinkageCreationContext'

const RepeatLinkageControl = ({ checked, count, onCheckedChange, onCountChange }) => {
  const bankContext = useContext(LinkageCreationContext)
  if (bankContext) return null
  return (
  <div className='flex flex-wrap items-center gap-3 md:col-span-2'>
    <label className='flex items-center gap-2 text-sm font-sans font-medium text-gray-700 cursor-pointer'>
      <input
        type='checkbox'
        checked={checked}
        onChange={event => onCheckedChange(event.target.checked)}
      />
      Repetir Vinculación
    </label>
    <select
      value={count}
      onChange={event => onCountChange(Number(event.target.value))}
      disabled={!checked}
      aria-label='Cantidad total de vinculaciones'
      className={`w-14 h-7 rounded-full text-xs font-medium py-0 pl-2 pr-5 border-gray-300 shadow-sm text-center ${
        checked
          ? 'focus:border-indigo-500 focus:ring-indigo-500'
          : 'bg-gray-100 text-gray-500 cursor-not-allowed'
      }`}
    >
      {REPEAT_LINKAGE_OPTIONS.map(option => (
        <option key={option} value={option}>{option}</option>
      ))}
    </select>
  </div>
)
}

export default RepeatLinkageControl
